import React from 'react';
import styled from 'styled-components/native';
import getPlatformType from '../../helpers/helpers';
const layoutType = getPlatformType();

let Container, Title, Discription, ButtonWrapper, CloseText;

Container = styled.View`
  width: ${layoutType == 'phone' ? '100%' : '460px'};
  margin: auto;
  align-items: center;
  padding: 25px 25px 0 25px;
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0px 7px 10px #9e9e9e;
`;
Title = styled.Text`
  width: 100%
  text-align: center;
  font-size: ${layoutType == 'phone' || layoutType == 'web' ? '16px' : '18px'};
  font-weight: bold;
  color: ${({ color }) => color};
  padding: 0 30px;
`;
CloseText = styled.Text`
  position: absolute;
  padding: 5px;
  right: 25px;
  font-size: 12px;
  font-weight: bold;
  color: #e71e82;
  color: ${({ color }) => color};
  cursor: pointer;
`;
Discription = styled.Text`
  color: ${({ color }) => color};
  font-size: ${layoutType == 'phone' || layoutType == 'web' ? '15px' : '16px'};
  margin-bottom: 10px;
  font-weight: 400;
  width: 100%;
  padding-top: 20px;
  text-align: center;
`;
ButtonWrapper = styled.View`
  width: 100%;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
  margin-bottom: 10px;
`;
export { Container, Title, Discription, ButtonWrapper, CloseText };
